import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import clearProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/ClearProduct";
import searchProducts from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SearchProducts";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import TextArea, { TextAreaPresentationProps } from "@insite/mobius/TextArea";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setQuickOrderInformation from "@waytek/Store/CommonHandlers/SetQuickOrderInformation";
import { CustomState } from "@waytek/Store/Reducers";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const { productCopyPaste, isLoadingMultipleProducts } = state.productInformationState;
    const { isUpdatingCart } = state.context;
    const { productsProcessed } = state.components.orderUpload;
    return { productCopyPaste, isLoadingMultipleProducts, isUpdatingCart, productsProcessed };
};

const mapDispatchToProps = {
    setQuickOrderInformation,
    clearProduct,
    searchProducts,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps> & HasHistory;

export interface QuickOrderCopyAndPasteStyles {
    wrapper?: InjectableCss;
    productsTextArea?: TextAreaPresentationProps;
    loadingContainer?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const quickOrderCopyAndPasteStyles: QuickOrderCopyAndPasteStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
            position: relative;
        `,
    },
    productsTextArea: {
        cssOverrides: {
            inputSelect: css`
                min-height: 122px;
            `,
        },
    },

    loadingContainer: {
        css: css`
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 1;
            background: rgba(255, 255, 255, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
};

const styles = quickOrderCopyAndPasteStyles;

const QuickOrderCopyAndPaste = ({
    productCopyPaste,
    isLoadingMultipleProducts,
    setQuickOrderInformation,
    isUpdatingCart,
}: Props) => {
    const copyPasteChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setQuickOrderInformation({
            setQty: false,
            productCopyPaste: event.target.value,
        });
        clearProduct();
        searchProducts({ query: "" });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            {(isLoadingMultipleProducts || isUpdatingCart) && (
                <StyledWrapper {...styles.loadingContainer}>
                    <LoadingSpinner {...styles.spinner} />
                </StyledWrapper>
            )}
            <TextArea
                {...styles.productsTextArea}
                label={translate("Copy & Paste Products")}
                value={productCopyPaste}
                onChange={copyPasteChangeHandler}
                disabled={isLoadingMultipleProducts}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(QuickOrderCopyAndPaste as any) as any) as any,
    definition: {
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
        displayName: "Copy & Paste [For Desktop]",
    },
};

export default widgetModule;
